import { render, staticRenderFns } from "./DocumentChecklist.vue?vue&type=template&id=304a6f1a"
import script from "./DocumentChecklist.vue?vue&type=script&lang=js"
export * from "./DocumentChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports